export const mergeVarianceActionPrefill = ({
  payload,
  prefill,
  preferPayloadEvidence = false,
} = {}) => {
  if (!prefill) return payload;
  if (!payload) return payload;
  const evidenceFirst = (payloadValue, prefillValue) => (
    preferPayloadEvidence ? payloadValue : (prefillValue || payloadValue)
  );
  return {
    ...payload,
    sourceEvidence: evidenceFirst(payload.sourceEvidence, prefill.sourceEvidence),
    targetEvidence: evidenceFirst(payload.targetEvidence, prefill.targetEvidence),
    sourceRowKey: evidenceFirst(payload.sourceRowKey, prefill.sourceRowKey),
    targetRowKey: evidenceFirst(payload.targetRowKey, prefill.targetRowKey),
    sourceProductName: evidenceFirst(payload.sourceProductName, prefill.sourceProductName),
    sourceProductCode: evidenceFirst(payload.sourceProductCode, prefill.sourceProductCode),
    sourcePrice: preferPayloadEvidence
      ? payload.sourcePrice
      : (prefill.sourcePrice ?? payload.sourcePrice),
    targetSource: preferPayloadEvidence
      ? payload.targetSource
      : (prefill.targetSource || payload.targetSource),
    targetLabel: preferPayloadEvidence
      ? payload.targetLabel
      : (prefill.targetLabel || payload.targetLabel),
    bindingMethod: payload.bindingMethod || prefill.bindingMethod,
    bindingConfidence: payload.bindingConfidence || prefill.bindingConfidence,
    metadata: {
      ...(prefill.metadata || {}),
      ...(payload.metadata || {}),
    },
  };
};
